'use client';

import { usePathname } from 'next/navigation';

import { Footer } from '@/app/_components/Footer';

interface LocalMarketLayoutProps {
  children: React.ReactNode;
}

const EXCLUDED_FOOTER_PATTERNS: RegExp[] = [
  /^\/welmarket\/order$/,
  /^\/welmarket\/cart/,
  /^\/welmarket\/orders/,
  /^\/welmarket\/brand$/,
];

export const LocalMarketLayout = ({ children }: LocalMarketLayoutProps) => {
  const pathname = usePathname();

  const shouldShowFooter =
    !EXCLUDED_FOOTER_PATTERNS.some((pattern) => pattern.test(pathname || ''));

  return (
    <>
      {children}
      {shouldShowFooter ? <Footer /> : null}
    </>
  );
};
